const Role = {

    // FIELDS
    "name": "الاسم",
    "description": "الوصف",
    "status": "الحالة",
    "search": "البحث",

    // PAGE HEADER
    "role": "الدور",

    // ERROR
    "error_name": "الرجاء إدخال الاسم",
    "error_desc": "الرجاء إدخال الوصف",
    "error_status": "الرجاء اختيار الحالة",

    // TABLE HEADER
    "table_name": "الاسم",
    "table_description": "الوصف",
    "table_status": "الحالة",

}

export default Role;